import React, { useState } from 'react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import {
    RecallItems,
    RecallsApiResponse,
} from '../../../services/recalls-service/recalls-service';
import { ExemptWordsListProps } from '../../pages/recalls/hook/use-exempt-word-list';
import RecallsList from '../recalls-list/recalls-list';

import RecallsMobileModal from '../recalls-mobile-modal/recalls-mobile-modal';

interface Props {
    content: RecallsUnitedContent;
    recallsData: RecallsApiResponse | null | undefined;
    exemptWordsList?: ExemptWordsListProps | null;
    vin?: string | null;
    isWebview: boolean;
    showRecalls: boolean;
    showCsp: boolean;
}

interface ModalContent {
    recall: RecallItems;
    showModal: boolean;
    isCsp: boolean;
}

const RecallsListMobile = (props: Props) => {
    const [modal, setModal] = useState<ModalContent>({
        recall: {} as RecallItems,
        showModal: false,
        isCsp: false,
    });
    const {
        content,
        recallsData,
        exemptWordsList,
        isWebview,
        showRecalls,
        showCsp,
    } = props;
    const handleOpenModal = (
        recall: RecallItems,
        showModal: boolean,
        isCsp: boolean
    ) => {
        document.body.style.overflow = 'hidden';
        setModal({ recall, showModal, isCsp });
    };
    const handleCloseModal = (recall: RecallItems, showModal: boolean) => {
        document.body.style.overflow = '';
        setModal({ recall, showModal, isCsp: false });
    };

    return (
        <div className="recalls-buttons-list-mobile-container">
            {modal.showModal && (
                <RecallsMobileModal
                    recall={modal.recall}
                    content={content}
                    isCsp={modal.isCsp}
                    exemptWordsList={exemptWordsList}
                    onClose={handleCloseModal}
                    vin={props.vin}
                    isWebview={isWebview}
                />
            )}
            <RecallsList
                content={content}
                recallsData={recallsData}
                handleShowRecall={handleOpenModal}
                exemptWordsList={exemptWordsList}
                showRecalls={showRecalls}
                showCsp={showCsp}
            />
        </div>
    );
};

export default RecallsListMobile;
